
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Shadow05:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M127.987 101.238C125.535 90.2865 89.4117 96.5241 61.4519 91.8578C27.2422 86.0964 0 84.8108 0 102.19C0 115.094 29.3653 115.475 60.4052 119.665C82.1152 122.617 128.884 105.19 127.987 101.238Z" fill="#0C0D0D"/>
</svg>

  }
  
